import React from 'react';
import './markersPage.scss';
import imageOne from './assets/markers_img_1_2x.png';
import imageTwo from './assets/markers_img_2_2x.png';
import {Helmet} from "react-helmet";

/**
 * The MarkersPage component.
 *
 * @constructor
 */
export class MarkersPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="markers-page" className="system-page">
        <Helmet>
          <title>Underground Facility Markers - NEI</title>
          <meta name = "description" content ="Underground facility markers are used to designate the general route of pipelines and other underground facilities." />
        </Helmet>
        <div className="container-fluid">
          <div className="row row-odd">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1>How to Identify Underground Facilities</h1>
                  <p>Underground facility markers are used to designate the general route of pipelines and other underground facilities. Markers are also found where pipelines and utilities cross a street, railroad or waterway, as well as areas where they emerge from the ground.</p>
                  <h2>Be Aware. Underground facility markers DO NOT</h2>
                  <ul>
                    <li>Indicate an exact location</li>
                    <li>Designate a straight line between markers</li>
                    <li>Specify facility depth, or</li>
                    <li>Signal the number of pipelines or utilities in an area</li>
                  </ul>
                  <p className="last"><strong>Warning: </strong>Underground utilities owned by the customer or those located in dense population areas may not be marked, and additional steps may be necessary before any digging occurs. For more information, please contact 811.</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-alt">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1>Permanent Pipeline Markers Come In Different Shapes And Sizes, But Will Always Include</h1>
                  <div className="text-center">
                    <img src={imageOne} alt="pipeline markers" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row row-even">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h1>Examples of Temporary Underground 811 Notification Markers</h1>
                  <p>The uniform color code that is used to mark the location of underground facilities. The markings will appear as paint, flags, stakes or whiskers.</p>
                  <img src={imageTwo} alt="Markers image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MarkersPage.propTypes = {};

export default MarkersPage;



// WEBPACK FOOTER //
// ./src/components/pages/markers/MarkersPage.js